export default function useEventsManager({ legacyConnector }) {
  const publish = ({
    actionType,
    projectId,
    itemId,
    itemType,
    subType,
    data = {},
    extraInfo = {},
  }) => {
    window.parent.app.ko.postbox.publish('allTWEvents', {
      eventTime: new Date(),
      itemType,
      subType,
      actionType,
      itemId,
      projectId,
      data,
      extraInfo,
    });
  };
  const publishAdd = ({ projectId, itemId, itemType, subType, data, extraInfo }) => {
    if (legacyConnector.isLegacyConnected.value) {
      publish({
        itemType,
        subType,
        actionType: window.parent.app.consts.ACTIONTYPE.ADDED,
        itemId,
        projectId,
        data,
        extraInfo,
      });
    }
  };

  const publishUpdate = ({ projectId, itemId, itemType, subType, data, extraInfo }) => {
    if (legacyConnector.isLegacyConnected.value) {
      publish({
        itemType,
        subType,
        actionType: window.parent.app.consts.ACTIONTYPE.UPDATED,
        itemId,
        projectId,
        data,
        extraInfo,
      });
    }
  };
  const publishDelete = ({ projectId, itemId, itemType, subType, data, extraInfo }) => {
    if (legacyConnector.isLegacyConnected.value) {
      publish({
        itemType,
        subType,
        actionType: window.parent.app.consts.ACTIONTYPE.DELETED,
        itemId,
        projectId,
        data,
        extraInfo,
      });
    }
  };

  const subscribe = (topic, handler) => {
    if (legacyConnector.isLegacyConnected.value) {
      const sub = window.parent.app.ko.postbox.subscribe(topic, handler);
      // this has a dispose method which should be called to clean up on destroy of
      // a component
      return sub;
    }

    // no-op
    return { dispose: () => {} };
  };

  // event related shenanigans
  return {
    publishAdd,
    publishDelete,
    publishUpdate,
    /**
     * The purpose of this function is to support subscribing to knockout-postbox events in the PWA applications
     * making an easier way to all next to react to changes that occur on a route where next frame
     * and PWA code cohabit
     * @param {Function} -  (handler)=> { // do stuff  });
     * @returns {Object} - { dispose } -  should be called on onUnMounted to cleanup
     */
    subscribe,
    topics: {
      allTWEvents: 'allTWEvents',
    },
  };
}
